import React from "react";

import { BottomNavigationAction, BottomNavigation } from "@material-ui/core";
import { AccountCircle, Store } from "@material-ui/icons";
import ListAltIcon from "@material-ui/icons/ListAlt";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import NotificationsIcon from "@material-ui/icons/Notifications";

import { Link, useLocation } from "react-router-dom";

import useStyles from "./style";

function BottomNav({ notActive }) {
  let location = useLocation();
  const classes = useStyles();
  return (
    <BottomNavigation
      className={classes.root}
      value={location.pathname}
      showLabels
    >
      <BottomNavigationAction
        className={classes.action}
        label="Katalog"
        value="/"
        component={Link}
        to="/"
        icon={<ListAltIcon />}
      />
      {notActive ? (
        <BottomNavigationAction
          className={classes.action}
          label="Toko Saya"
          value="/tokosaya"
          component={Link}
          to="/tokosaya"
          icon={<Store />}
        />
      ) : (
        ""
      )}

      <BottomNavigationAction
        className={classes.action}
        label="Transaksi"
        value={
          !notActive
            ? "/transaksi/transaksilist/sellerapp/tokorame"
            : "/transaksi"
        }
        component={Link}
        to={
          !notActive
            ? "/transaksi/transaksilist/sellerapp/tokorame"
            : "/transaksi"
        }
        icon={<CreditCardIcon />}
      />
      <BottomNavigationAction
        className={classes.action}
        label="Notifikasi"
        value="/notification/aplikasi"
        component={Link}
        to="/notification/aplikasi"
        icon={<NotificationsIcon />}
      />
      <BottomNavigationAction
        className={classes.action}
        label="Akun"
        value="/akun"
        component={Link}
        to="/akun"
        icon={<AccountCircle />}
      />
    </BottomNavigation>
  );
}

export default BottomNav;
